import { action } from 'typesafe-actions';

import ActionType from './constants';

const clearErrors = (actions: string[]) =>
  action(ActionType.CLEAR_ERRORS, { actions });
export default clearErrors;
